import { bov3_api } from '../..';
import { PropertyType } from '../../../common';

export const getSessionLogs = (data: PropertyType): Promise<PropertyType> =>
	bov3_api
		.post(``, {
			sid: data.token,
			session_id: data.session_id,
			action: 'get_log',
			request: 'HandleSession',
			params: { context_len: data.context_len || 20000 },
		})
		.then((res) => {
			return res;
		});

export const pingSession = (data: PropertyType, soft: boolean): Promise<PropertyType> =>
	bov3_api
		.post(``, {
			sid: data.token,
			session_id: data.session_id,
			action: soft ? 'ping' : 'pingit',
			request: 'HandleSession',
		})
		.then((res) => {
			return res;
		});

export const closeSession = (data: PropertyType): Promise<PropertyType> =>
	bov3_api
		.post(``, { sid: data.token, session_id: data.session_id, action: 'close_session', request: 'HandleSession' })
		.then((res) => {
			return res;
		});
